import { AuthenticatedUserProfile } from 'src/types/AuthenticatedUserProfile';
import { ContentDetailAccess } from 'src/types/ContentDetailAccess';

export default function isAllowedAccessToContent(
	contentDetailAccess: ContentDetailAccess | undefined,
	authenticatedUserProfile?: AuthenticatedUserProfile
): boolean {
	if (!contentDetailAccess) {
		return true;
	}

	if (contentDetailAccess?.OpenAccess.AllowAccess) {
		return true;
	}

	if (authenticatedUserProfile?.isRcnStaffMember) {
		return true;
	}

	if (authenticatedUserProfile && contentDetailAccess?.RegisteredUser.AllowAccess) {
		return true;
	}

	if (authenticatedUserProfile?.isActiveMember && contentDetailAccess?.RcnMember.AllowAccess) {
		return true;
	}

	if (authenticatedUserProfile?.isActiveRcniSubscriber && contentDetailAccess?.RcniPlusSubscriber.AllowAccess) {
		return true;
	}

	return false;
}
